import { formatNumber } from "accounting"

import { INCOGNITO_MASK } from "../../../Components/Private"
import { formatCurrency } from "../../../Utils/utils"

// Copied from DashboardPage/components/ChartAlertsBySource/plugins.js (the Alerts
// by Source legend) and adapted for reason data: header "Reason / Count / Value",
// colour box + label + count + value per row, no source logos. Clicking a row
// toggles that slice's visibility (strike-through + the pie + centre total update),
// exactly like Alerts by Source. setFilterData lets the card recompute the total.
const getOrCreateLegendList = (chart, id) => {
  const legendContainer = document.getElementById(id)
  if (!legendContainer) return null
  let listContainer = legendContainer.querySelector("ul")
  if (!listContainer) {
    listContainer = document.createElement("ul")
    listContainer.classList.add("ul-wrapper")
    listContainer.style.display = "flex"
    listContainer.style.flexDirection = "column"
    legendContainer.appendChild(listContainer)
  }
  return listContainer
}

export const reasonLegendPlugin = (setFilterData, t = (s) => s, incognito = false) => ({
  id: "htmlLegend",
  afterUpdate(chart, args, options) {
    const ul = getOrCreateLegendList(chart, options.containerID)
    if (!ul) return

    while (ul.firstChild) ul.firstChild.remove()

    const items = chart.options.plugins.legend.labels.generateLabels(chart)
    items.unshift({ text: t("Channel"), column1: t("Count"), column2: t("Volume ($)") })

    items.forEach((item, i) => {
      const li = document.createElement("li")
      li.style.alignItems = "center"
      li.style.display = "flex"
      li.style.flexDirection = "column"

      const empty = i !== 0 && !chart.data.datasets?.[0].count[i - 1]

      if (empty) {
        li.style.opacity = "0.4"
      } else if (i !== 0) {
        li.style.cursor = "pointer"
        li.onclick = () => {
          if (setFilterData) setFilterData((prev) => ({ ...prev, [item.text]: !item.hidden }))
          chart.toggleDataVisibility(item.index)
          chart.update()
        }
      }

      const first_line = document.createElement("div")
      first_line.classList.add("first_line")

      const boxSpan = document.createElement("div")
      boxSpan.classList.add("legend-color-box")
      boxSpan.style.background = item.fillStyle
      boxSpan.style.display = "inline-block"
      boxSpan.style.height = "8px"
      boxSpan.style.width = "8px"
      boxSpan.style.marginRight = "12px"

      // The name takes whatever Count and Volume leave, so the row never grows past the card:
      // fixed percentages plus the colour box overflowed a phone-width card and cut Volume off.
      const textContainer = document.createElement("p")
      textContainer.style.flex = "1 1 0"
      textContainer.style.minWidth = "0"
      if (i === 0) {
        textContainer.style.color = "#7A7A83"
      } else {
        textContainer.style.textDecoration = item.hidden ? "line-through" : ""
      }
      textContainer.appendChild(document.createTextNode(" " + item.text))

      const textContainer2 = document.createElement("p")
      textContainer2.style.flex = "0 0 20%"
      textContainer2.style.textAlign = "center"
      if (i === 0) {
        textContainer2.style.color = "#7A7A83"
        textContainer2.appendChild(document.createTextNode(item.column1))
      } else {
        textContainer2.appendChild(
          document.createTextNode(
            incognito ? INCOGNITO_MASK : formatNumber(chart.data.datasets?.[0].count[i - 1], 0, ",")
          )
        )
      }

      const textContainer3 = document.createElement("p")
      textContainer3.style.flex = "0 0 28%"
      textContainer3.style.textAlign = "end"
      textContainer3.style.whiteSpace = "nowrap"
      if (i === 0) {
        textContainer3.style.color = "#7A7A83"
        textContainer3.appendChild(document.createTextNode(item.column2))
      } else {
        textContainer3.appendChild(
          document.createTextNode(
            incognito ? INCOGNITO_MASK : formatCurrency(chart.data.datasets?.[0].volume[i - 1])
          )
        )
      }

      li.appendChild(first_line)
      if (i !== 0) first_line.appendChild(boxSpan)
      first_line.appendChild(textContainer)
      first_line.appendChild(textContainer2)
      first_line.appendChild(textContainer3)
      ul.appendChild(li)
    })
  }
})
